import PageContent from './components/PageContent'

const PortalSyncs = () => (
  <PageContent />
)

export default PortalSyncs
